import * as React from 'react';

import NavigationItem from './NavigationItem';

import * as personal from '../../assets/image/personal.png';
import * as active from '../../assets/image/active.svg';
import * as communication from '../../assets/image/communication.svg';
import * as payments from '../../assets/image/payments.svg';
import * as activeTabImage from '../../assets/image/activeActivity.svg';
import * as userImage from '../../assets/image/user.svg';
import * as communicationActiveImage from '../../assets/image/activeCommunication.svg';
import * as paymentsActiveImage from '../../assets/image/activePayments.svg';

import NavigationDescription from '../../interfaces/NavigationDescription';

import './style.scss';

function NavigationTab () {

  const personalNav: NavigationDescription[] = [
    {
      image: userImage,
      activeImage: personal,
      text: 'Personal Info',
    },
    {
      image: active,
      text: 'Activity',
      activeImage: activeTabImage,
    },
    {
      image: communication,
      text: 'Communication',
      activeImage: communicationActiveImage,
    },
    {
      image: payments,
      text: 'Payments Info',
      activeImage: paymentsActiveImage,
    },
  ];

  return (
    <nav className='tab-navigation d-flex justify-center align-center' >
      {
        personalNav.map((navItem, key) => {
          return(
            <NavigationItem
              activeImage={navItem.activeImage}
              item={key}
              navLength={personalNav}
              key={key}
              image={navItem.image}
              text={navItem.text} />
          );
        })
      }
    </nav>
  );
}

export default React.memo(NavigationTab);
